import AnnouncementBarRoot from './Root'
export type { AnnouncementBarRootChildrenProps } from './Root'

export const AnnouncementBar = {
  Root: AnnouncementBarRoot,
}
